module.exports = __webpack_public_path__ + "fonts/Inter-400-latin49.30a274c.woff2";